import { RichContent } from 'ricos-schema';
import { createParagraphNode, createTextNode, initializeMetadata } from '../../nodeUtils.js';
import '../../../ReadonlyNonEmptyArray-0e481d0b.js';
import '../../../string-40bcd6bf.js';
import 'lodash';
import 'uuid';
import '../../../utils.js';
import '../../generateRandomId.js';

const fromPlainText = (text) => {
  const paragraphs = text.split("\n").map(
    (paragraph) => createParagraphNode(paragraph ? [createTextNode(paragraph)] : [])
  );
  const content = {
    nodes: paragraphs,
    metadata: initializeMetadata()
  };
  return RichContent.fromJSON(content);
};

export { fromPlainText };
//# sourceMappingURL=fromPlainText.js.map
